import { IconButton, IconButtonProps } from "@mui/material";
import { FunctionComponent } from "react";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';



interface CloseButtonProps extends IconButtonProps{

}

const CloseButton: FunctionComponent<CloseButtonProps> = (props) => {
  return ( <>
    <IconButton {...props}><CloseRoundedIcon/></IconButton>
  </> );
}

export default CloseButton;
